import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { disconnect, connect, sendScript } from './WebSerialUtils';
import { blinkCode } from '../utils/SetupESP32Stubs';

let port = null;
let writer = null;
let reader = null;

function FlashMicroPythonCard(props) {
  const [stepIdx, setStepIdx] = useState(0);
  const [errorMsg, setErrorMsg] = useState(null);

  let errorComponent = '';
  if (errorMsg !== null) {
    errorComponent = <div className="py-2 text-danger">Error: {errorMsg}</div>;
  }

  const steps_old = [
    `Before you do anything, locate the "BOOT" button on your
ESP32. Don't press it yet, but you will!`,
    //`Right-click &#8594; Save-as... the <a href="https://micropython.org/resources/firmware/esp32-20210418-v1.15.bin">Micropython *.bin firmware file</a>.`,
    `Connect the ESP32 to your computer using the micro-USB cord.`,
    `<b>Confirm</b>: the RED LED on the ESP32 lights up`,
    `<b>Ctrl + Click</b> <a href="https://adafruit.github.io/Adafruit_WebSerial_ESPTool/" target="_blank" rel="noopener noreferrer">the Adafruit ESPTool</a> to open in a separate browser tab.`,
    `In the ESPTool web tab: Select "115200 Baud"<br/><br/>FYI: Baud is a fancy way for saying 'bits-per-second'. This specifies the connection speed to the ESP32. More does not mean better!`,
    `In the ESPTool web tab: Read all sub-steps before doing... Click the "Connect" button<ol><li>When prompted, select the serial port connected to your ESP32.<ul><li>For Mac: it will likely be /dev/tty.SLAB...</li><li>For Windows: COM...</li><li>For Linux: /dev/ttyUSB...</li></ul></li><li>During the connection "Timed out after..." process, press/release the "BOOT" button on the ESP32 a couple of times... until you see the "UPLOAD" panel appear.</li></ol>`,
    `In the "UPLOAD" panel that appeared: Click the "ERASE" button.`,
    `"ERASE" completed?`,
    `In the "UPLOAD" panel: On the top-most "Offset" line...<ol><li>Delete the "0".</li><li>Enter 1000 so it reads "Offset 0x1000" (see image below).</li></ol><br/><center><img src="/theme/images/build_setup_hadabot/setup_esp32_0x1000_offset.png"></img></center>`,
    `In the "UPLOAD" panel: Click "Choose a file...",  find the downloaded MicroPython esp32-*.bin file.`,
    `In the "UPLOAD" panel: : Click "Program"... be patient.`,
    `In the ESPTool web tab: When "Program" completes, click the "Disconnect" button (upper right of web page). <br/><small>*It is important to do this step to release the serial port connection.</small>`,
    `Close the ESPTool web tab.`,
    `Reset the ESP32: On the ESP32, reset the board by pressing / releasing the "EN" button on the ESP32 board.<br/><small>*Unfortunately, nothing physically happens on the ESP32 board that will signal the success of this reset.</small>`,
    `Test the upload by clicking the "Test Blink" button below. Did the onboard LED on the ESP32 blink 5 times?<br/><br/>If so, congrats! You successfully flashed MicroPython on the ESP32. You're all set! `,
  ];

  const steps = [
    //`<a href="https://micropython.org/resources/firmware/esp32-20210623-v1.16.bin" target="_blank">Download the ESP32 MicroPython firmware to you host machine</a> (Right-click <span>&#8594;</span> Save-As). Make a note of where you saved the firmware file.`,
    `<a href="https://micropython.org/resources/firmware/esp32-20220117-v1.18.bin" target="_blank">Download the ESP32 MicroPython firmware to you host machine</a> (Right-click <span>&#8594;</span> Save-As). Make a note of where you saved the firmware file.`,
    `(1) <b>Ctrl + Click</b> <a href="/setup-esp32-flash-micropython-esptool.html" target="_blank" rel="noopener noreferrer">the Hadabot ESP32 Firmware Flash Tool (ESPTool)</a> to open the page in a separate browser tab. (2) Follow the instructions on that page to flash the MicroPython *.bin file you downloaded. (3) Return back here when you are done, so we can test the firmware.`,
    `Done? Great! Close the ESPTool web tab.`,
    `Reset the ESP32: On the ESP32, reset the board by pressing / releasing the "EN" button on the ESP32 board.<br/><small>*Unfortunately, nothing physically happens on the ESP32 board that will signal the success of this reset.</small>`,
    `Test the upload by clicking the "Test Blink" button below. Did the onboard LED on the ESP32 blink 5 times?<br/><small>*There are two (2) ESP32 LEDs - a red LED for power (which stays lit), the other blue 'onboard' LED should be the one that blinks.</small><br/><br/>If so, congrats! You successfully flashed MicroPython on the ESP32. You're all set! `,
  ];

  let listGroupItems = [];
  steps.forEach((s, idx) => {
    if (idx <= stepIdx) {
      const prefix =
        idx === stepIdx ? `Step ${idx + 1}` : `(DONE) Step ${idx + 1}`;
      const isDisabled = idx === stepIdx ? false : true;
      listGroupItems.push(
        <ListGroup.Item
          key={`li${idx}`}
          dangerouslySetInnerHTML={{ __html: `${prefix}: ${s}` }}
          disabled={isDisabled}
        ></ListGroup.Item>
      );
    }
  });

  let footerCta = (
    <ButtonGroup style={{ width: '100%' }}>
      <Button
        block
        variant="primary"
        onClick={() => {
          setStepIdx(stepIdx + 1);
        }}
      >
        Done: Next Step Please!
      </Button>
      <DropdownButton as={ButtonGroup} title="" id="bg-nested-dropdown">
        <Dropdown.Item
          eventKey="1"
          onClick={() => {
            setStepIdx(steps.length - 1);
          }}
        >
          Show All Steps
        </Dropdown.Item>
      </DropdownButton>
    </ButtonGroup>
  );
  if (stepIdx === steps.length - 1) {
    footerCta = (
      <div>
        <Button
          block
          variant="primary"
          onClick={() => {
            connect(port, writer, reader)
              .then(([p, w, r]) => {
                port = p;
                writer = w;
                reader = r;
                sendScript(blinkCode.code, writer).then(() => {
                  disconnect(port, writer, reader);
                  port = null;
                  writer = null;
                  reader = null;
                });
              })
              .catch((ex) => {
                setErrorMsg(
                  `${ex.message} - perhaps you didn't "Disconnect" from the ESP Tool page?`
                );
                disconnect(port, writer, reader);
                port = null;
                writer = null;
                reader = null;
              });
          }}
        >
          Test MicroPython: Blink the ESP32's LED 5 times.
        </Button>
        <div className="text-center">
          <small>
            * Upon clicking the Test button, please select the serial port your
            ESP32 is connected to.
          </small>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} className="text-left">
          <Card className="border-primary">
            <Card.Header className="bg-primary text-white">
              Flash the MicroPython firmware on to the ESP32
            </Card.Header>
            <Card.Body className="text-dark">
              <ListGroup as="ul" variant="flush">
                {listGroupItems}
              </ListGroup>
              {errorComponent}
            </Card.Body>
            <Card.Footer className="text-primary">{footerCta}</Card.Footer>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default FlashMicroPythonCard;
